
import {Options, Vue} from "vue-property-decorator";

@Options({
  components: {}
})
export default class FormPartAConfirmation extends Vue {

}

